import { ReactNode, Fragment } from 'react';
import { Card, CardContent, Grid, Typography } from '@mui/material';

type BindCardProps = {
  children: {
    title?: string;
    content?: ReactNode;
  }[];
  dialogs?: ReactNode;
};

export const BindCard = ({ children, dialogs = [] }: BindCardProps) => {
  const cardMargin = '10px 8px 10px 8px';
  return (
    <Card
      elevation={1}
      sx={{
        marginBottom: 1,
        backgroundColor: 'transparent',
      }}
    >
      <CardContent>
        <Grid
          className='card-content-map-grid'
          sx={{
            width: '100%',
            flexDirection: 'row',
          }}
        >
          {children.map(({ title, content }) => (
            <Fragment key={`${title}-${content?.toString}`}>
              {title ? (
                <Grid size={{ xs: 12, sm: 12, md: 12 }}>
                  <Typography
                    variant='h6'
                    sx={{
                      display: 'block',
                      margin: cardMargin,
                    }}
                  >
                    {title}
                  </Typography>
                </Grid>
              ) : null}
              {content ? (
                <Grid
                  className='card-content-map-grid'
                  container
                  sx={{
                    padding: cardMargin,
                    borderBottom: '1px solid dr',
                    width: '100%',
                  }}
                >
                  {content}
                </Grid>
              ) : null}
            </Fragment>
          ))}
        </Grid>
        {dialogs}
      </CardContent>
    </Card>
  );
};
